import React, { useContext, useRef, useState } from 'react';
import { LocaleContext } from 'shared';
import { useOnClickOutside } from 'shared/hooks';

import {
  AccountsDropdownContainer,
  AccountsDropdownItem,
  AccountsDropdownWrapper,
  Link,
} from './AccountsDropdown.styles';
import { AccountsDropdownProps } from './AccountsDropdown.types';

export const AccountsDropdown = ({ activeItem, items, onSelect }: AccountsDropdownProps) => {
  const localeContext = useContext(LocaleContext);
  const [isOpened, setOpened] = useState(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    setOpened(false);
  });

  const toggleOpened = () => {
    setOpened(!isOpened);
  };

  const handleSelect = (key: string) => () => {
    onSelect(key);
    toggleOpened();
  };

  return (
    <AccountsDropdownContainer>
      <AccountsDropdownWrapper className={`accounts-dropdown ${isOpened ? 'accounts-dropdown--opened' : ''}`} ref={ref}>
        <AccountsDropdownItem
          className="accounts-dropdown__item accounts-dropdown__item--active"
          onClick={toggleOpened}
        >
          <span>{activeItem.label}</span>
        </AccountsDropdownItem>

        {isOpened &&
          items.map(a => (
            <Link to={`/${a.key}/dashboard`} onClick={handleSelect(a.key)} key={a.key}>
              <AccountsDropdownItem className="accounts-dropdown__item">
                <span>{a.label}</span>
              </AccountsDropdownItem>
            </Link>
          ))}

        {isOpened && (
          <Link to={`/add-account`} onClick={toggleOpened}>
            <AccountsDropdownItem className="accounts-dropdown__item accounts-dropdown__item--new">
              <span>{localeContext.formatMessage({ id: 'SIDEBAR.NEW-ACCOUNT' })}</span>
            </AccountsDropdownItem>
          </Link>
        )}
      </AccountsDropdownWrapper>
    </AccountsDropdownContainer>
  );
};
